module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Label":"Close"},"fr":{"Label":"Fermer"}}')
  delete Component.options._Ctor
}
